import { createContext } from 'react';

/**
 * @type {React.Context<boolean>}
 */
const HomePageContext = createContext(false);

export const HomePageProvider = HomePageContext.Provider;
export const HomePageConsumer = HomePageContext.Consumer;

export default HomePageContext;
